<template>
  <div class="content ">
    <div class="app"></div>
    <div class="con-mb content-item flex-space-between">
      <div class="con-info">
        <p style="color:#474747">特定行业业务需求的订制化开发，实现业务与建筑物的智能互动</p>
        <p style="color:#515a65"></p>
        <!--<button class="con-info-detail" style="border:2px solid #8191ff;background: #8191ff;color:#fff">体验demo</button>-->
        <button class="con-info-detail" @click="comment" style="border:2px solid #e83439;background: transparent;color:#e83439">联系我们</button>
      </div>
      <div class="con-mb-img_p flex-center">
        <img class="con-mb-img" src="../../../assets/software_2.png"/>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "app2",
      methods:{
        comment(){
          this.$emit('comment')
        }
      }
    }
</script>

<style scoped>
  @import "../../../style.css";
  @import "../smart_mall_pc.css";
  @import "../smart_mall_mini.css";
</style>



// WEBPACK FOOTER //
// src/components/smart_mall/block/app3.vue